import { StyledSubTitle } from './subTitle.styles';

export default StyledSubTitle;
